import React__default from 'react';
import SubjectIcon from '@material-ui/icons/Subject';
import { KubernetesDialog } from '../../KubernetesDialog/KubernetesDialog.esm.js';
import { PodLogs } from './PodLogs.esm.js';

const PodLogsDialog = ({ containerScope }) => {
  return /* @__PURE__ */ React__default.createElement(
    KubernetesDialog,
    {
      buttonAriaLabel: "get logs",
      buttonIcon: /* @__PURE__ */ React__default.createElement(SubjectIcon, null),
      buttonText: "Logs",
      disabled: false,
      title: `${containerScope.podName} - ${containerScope.containerName} logs on cluster ${containerScope.cluster.title || containerScope.cluster.name}`
    },
    /* @__PURE__ */ React__default.createElement(PodLogs, { containerScope })
  );
};

export { PodLogsDialog };
//# sourceMappingURL=PodLogsDialog.esm.js.map
